import { toast } from 'react-hot-toast';


export function validateNumberInput(event) {
  const theEvent = event || window.event;
  let key;
  if (theEvent.type === 'paste') {
    key = event.clipboardData.getData('text/plain');
  } else {
    key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  const regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export const showToast = (type, message) => {
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  } else if (type === 'loading') {
    toast.loading(message);
  } else {
    toast(message);
  }
};

export const formatCuit = (cuitNumber) => {
  let cuitStr = cuitNumber.toString();

  cuitStr = cuitStr.padStart(11, '0');

  const part1 = cuitStr.slice(0, 2);
  const part2 = cuitStr.slice(2, 10);
  const part3 = cuitStr.slice(10);

  return `${part1}-${part2}-${part3}`;
};

export function convertISOToDateString(date) {
  const day = String(date.getDate()).padStart(2, '0'); 
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}